import { useEffect, useState } from 'react';

// Returns the current epoch millis, refreshed on interval boundaries (e.g. every
// minute at :00) and when the tab becomes visible again. Used to keep
// time-relative UI (e.g. the "waiting for response" minutes badge and its
// orange→red threshold) ticking without a per-item timer.
export const useNow = (intervalMs = 30000): number => {
  const [now, setNow] = useState<number>(() => Date.now());

  useEffect(() => {
    const tick = () => setNow(Date.now());
    let intervalId: ReturnType<typeof setInterval> | undefined;
    const timeoutId = setTimeout(
      () => {
        tick();
        intervalId = setInterval(tick, intervalMs);
      },
      intervalMs - (Date.now() % intervalMs)
    );
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') tick();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [intervalMs]);

  return now;
};

export default useNow;
